import React, { useState } from "react";
import toUpper from "lodash/toUpper";
import snakeCase from "lodash/snakeCase";
import { useTranslation } from "react-i18next";
import { Wizard } from "components/common";
import useHistory from "routing/useHistory";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import ForwarderRoutes from "forwarder/Routes";
import WelcomeStep from "./WelcomeStep";
import SelectForwarderStep from "./SelectForwarderStep";
import ConfigureForwarderStep from "./ConfigureForwarderStep";
import AddInputsStep from "./AddInputsStep";
import SummaryStep from "./SummaryStep";
import ForwarderWizardProvider from "./ForwarderWizardProvider";
const STEP_KEYS = ["welcome", "select-forwarder", "configure-forwarder", "inputs", "summary"];
const ForwarderWizard = ({ forwarderId = void 0 }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const [activeStep, setActiveStep] = useState(forwarderId ? STEP_KEYS[2] : STEP_KEYS[0]);
  const history = useHistory();
  const sendTelemetry = useSendTelemetry("forwarder-wizard");
  const triggerTelemetry = (event) => {
    sendTelemetry(event, {
      app_pathname: "forwarder"
    });
  };
  const onWizardStepChange = (step) => {
    setActiveStep(step);
    triggerTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER[`FORWARDER_WIZARD_${toUpper(snakeCase(step))}_STEP_OPENED`]);
  };
  const introSteps = [
    {
      key: STEP_KEYS[0],
      title: /* @__PURE__ */ React.createElement(React.Fragment, null, t("forwarder_wizard.steps.welcome")),
      component: /* @__PURE__ */ React.createElement(WelcomeStep, { onStepComplete: () => onWizardStepChange(STEP_KEYS[1]) })
    },
    {
      key: STEP_KEYS[1],
      title: /* @__PURE__ */ React.createElement(React.Fragment, null, t("forwarder_wizard.steps.select_forwarder")),
      component: /* @__PURE__ */ React.createElement(SelectForwarderStep, { onStepComplete: () => onWizardStepChange(STEP_KEYS[2]) })
    }
  ];
  const configureSteps = [
    {
      key: STEP_KEYS[2],
      title: /* @__PURE__ */ React.createElement(React.Fragment, null, t("forwarder_wizard.steps.configure_forwarder")),
      component: /* @__PURE__ */ React.createElement(ConfigureForwarderStep, { forwarderId, onStepComplete: () => onWizardStepChange(STEP_KEYS[3]) })
    },
    {
      key: STEP_KEYS[3],
      title: /* @__PURE__ */ React.createElement(React.Fragment, null, t("forwarder_wizard.steps.add_inputs")),
      component: /* @__PURE__ */ React.createElement(AddInputsStep, { onStepComplete: () => onWizardStepChange(STEP_KEYS[4]) })
    },
    {
      key: STEP_KEYS[4],
      title: /* @__PURE__ */ React.createElement(React.Fragment, null, t("forwarder_wizard.steps.summary")),
      component: /* @__PURE__ */ React.createElement(
        SummaryStep,
        {
          hideConfigureAnother: !!forwarderId,
          onWizardExit: () => history.push(ForwarderRoutes.LIST),
          onWizardRestart: () => onWizardStepChange(STEP_KEYS[1])
        }
      )
    }
  ];
  const steps = forwarderId ? configureSteps : [...introSteps, ...configureSteps];
  return /* @__PURE__ */ React.createElement(ForwarderWizardProvider, null, /* @__PURE__ */ React.createElement(
    Wizard,
    {
      steps,
      activeStep,
      onStepChange: onWizardStepChange,
      horizontal: true,
      justified: true,
      containerClassName: "",
      hidePreviousNextButtons: true
    }
  ));
};
export default ForwarderWizard;
